import { ModalBuilder, notifySuccess } from "@redriver/cinnamon";
import React from "react";
import { Button, DropdownItem, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { submitSheet } from "./actions";
import { useDispatch } from "react-redux";
import { validateSheetForApproval } from "features/Agreements/AgreementsList/SheetActions/actions";

const SubmitSheet = ({
  sheet,
  onSubmitted,
  generateDocument,
  boilerPlateTandCsId,
}) => {
  const { t } = useTranslation("agreements", { keyPrefix: "SheetActions" });
  const dispatch = useDispatch();
  const { sheetName } = sheet;
  const sheetId = sheet.sheetId ?? sheet.id;

  const translationPrefix = process.env.TRADE_AS_IPS
    ? "SubmitSheetIps"
    : "SubmitSheetPrincipal";

  const submitDisabled =
    sheet.missingCredit || (!boilerPlateTandCsId && process.env.TRADE_AS_IPS);

  return (
    <ModalBuilder
      loadAction={validateSheetForApproval}
      loadParams={{ sheetId, isDocuSign: false }}
      submitAction={submitSheet}
      submitParams={{ sheetId }}
      onSubmitted={() => {
        dispatch(notifySuccess("Sheet successfully submitted"));
        onSubmitted();
      }}
      renderTrigger={(onTrigger) =>
        generateDocument ? (
          <Button
            className="generate-btn"
            primary
            onClick={onTrigger}
            disabled={submitDisabled}
          >
            <Icon name="check" />
            {t(`${translationPrefix}.TriggerText`)}
          </Button>
        ) : (
          <DropdownItem onClick={onTrigger} disabled={submitDisabled}>
            {t(`${translationPrefix}.TriggerText`)}
          </DropdownItem>
        )
      }
      renderModal={(modalProps, data, state) => (
        <>
          <TranslatedModal.Confirmation
            {...modalProps}
            // The check below is for validation e.g. if object is empty then an error occurred as IsValid wasn't returned.
            // See (ValidateSheetForApprovalEndpoint + Query)
            submitDisabled={!data?.isValid || state.submitting}
            header={t(`${translationPrefix}.ModalHeader`)}
            content={t(`${translationPrefix}.ModalContent`, { sheetName })}
          />
        </>
      )}
    />
  );
};
export default SubmitSheet;
